import { notLoginInstance } from './axiosInterceptor';

export const doLogin = async loginParam => {
  const response = await notLoginInstance.post('/login.do', loginParam);
  return response.data.results;
};

export const doLogout = async logoutParam => {
  try {
    const response = await notLoginInstance.post(
      'logout.do',
      { token: logoutParam },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error; 
  }
};

export const getAuthrtMenuList = async authrtId => {
  const response = await notLoginInstance.post(
    '/beforeLogin/menu.do',
    { authrtId: authrtId }
  );

  return response.data.results;
};
